import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import AdminModal from '../AdminModal.js';
import AdminDetailList from '../AdminDetailList.js';

const ResetPasswordModal = ({ isOpen, onClose, onConfirm, user, loading }) => (
  <AdminModal
    isOpen={isOpen && !!user}
    onClose={onClose}
    title="Reset Password"
    actions={(
      <>
        <button className="cancel-button" onClick={onClose} disabled={loading}>
          Cancel
        </button>
        <button className="admin-submit-button" onClick={onConfirm} disabled={loading}>
          {loading ? <FontAwesomeIcon icon={faSpinner} spin /> : 'Reset Password'}
        </button>
      </>
    )}
  >
    <p>Are you sure you want to reset the password for this user?</p>
    <AdminDetailList
      rows={[
        { label: 'User Name:', value: user?.name },
        { label: 'Email:', value: user?.email },
      ]}
    />
    <p style={{ marginTop: '15px', color: '#666', fontSize: '14px' }}>
      The user will receive instructions to set a new password via email.
    </p>
  </AdminModal>
);

export default ResetPasswordModal;
